// Les traductions de l'import IA sont isolées pour garder le vocabulaire dense hors du fichier racine.
const COLLABORATOR_AI_IMPORT_FR = {
  AI_IMPORT: {
    BUTTON: "Importer avec l'IA",
    EYEBROW: 'Import collaborateurs et contrats',
    TITLE: 'Assistant d’import IA',
    WORKFLOW: {
      NO_ARCHIVE: "Ces fichiers sont lus pour l'analyse uniquement. Ils ne sont ni archives dans la GED, ni deposes dans un dossier, ni associes aux contrats. Aucun depot documentaire reserve aux administrateurs n'est garanti par cet import.",
      DESCRIPTION: 'Les sources sont analysees ensemble puis rapprochees. Les contradictions sans preuve de date restent a confirmer avant toute ecriture.',
      RECOMMENDED: '(recommande)', ACCEPT_ANSWER: 'Valider cette reponse', DECISIONS: 'Decisions et preuves retenues',
      ADMINISTRATOR: 'Votre reponse explicite', APPROVE_SELECTED_READY: 'Valider les lignes pretes selectionnees',
      EXACT_APPROVAL: "Cette confirmation approuve uniquement le plan exact affiche. Toute modification impose une nouvelle confirmation.",
      PARTIAL_SELECTION: "Les lignes exclues ne sont pas importees. Les dependances affichees sont incluses dans cette confirmation globale.",
      STATUS: { running: 'Traitement en cours', waiting_question: 'Votre reponse est necessaire', awaiting_approval: 'Plan pret pour validation globale', completed: 'Traitement termine', limit_reached: 'Limite globale atteinte', failed: 'Traitement interrompu' },
    },
    // Les étapes décrivent le parcours complet sans exposer les noms techniques backend.
    STEPS: {
      LABEL: "Étapes de l'import",
      FILES: 'Fichiers',
      ANALYSIS: 'Analyse',
      REVIEW: 'Revue',
      EXECUTION: 'Import',
      SUMMARY: 'Bilan',
    },
    // Les actions couvrent les boutons communs et les validations unitaires ou par lot.
    ACTION: {
      CLOSE: 'Fermer',
      CANCEL: 'Annuler',
      REMOVE_FILE: 'Retirer le fichier',
      ANALYZE: 'Analyser les fichiers',
      RECONCILE: 'Appliquer les corrections',
      REVIEW: 'Examiner',
      PREVIOUS: 'Précédent',
      NEXT: 'Suivant',
      EXECUTE_SELECTED: 'Importer la sélection',
      EXECUTE_ALL_READY: 'Importer toutes les lignes prêtes',
      CONFIRM_EXECUTION: "Confirmer l'import",
      CANCEL_AFTER_CURRENT: 'Arrêter après les opérations en cours',
      CLOSE_SUMMARY: 'Fermer le bilan',
    },
    UNIT: { BYTE: 'o', KILOBYTE: 'Ko', MEGABYTE: 'Mo' },
    FILES: {
      KICKER: 'Sources',
      TITLE: 'Sélectionner les fichiers',
      DESCRIPTION: 'Ajoutez des fichiers CSV, XLS, XLSX ou des PDF contenant chacun un seul contrat.',
      COUNT: 'fichiers sélectionnés',
      // La tarification est affichée avant analyse avec le total calculé depuis les fichiers acceptés.
      CREDIT_COST: 'Cet import consommera {{count}} crédits (10 + 1 par fichier).',
      DROP_TITLE: 'Déposez vos fichiers ici',
      DROP_HINT: 'ou cliquez pour les sélectionner',
    },
    FILE_STATUS: {
      QUEUED: "En attente",
      ACTIVE: 'En cours',
      DONE: 'Terminé',
      FAILED: 'Échec',
    },
    ANALYSIS: {
      KICKER: 'Extraction OCR et IA',
      TITLE: 'Analyse des données',
      DESCRIPTION: "Jusqu'à 10 fichiers sont traités en parallèle. Les PDF passent par le service OCR ingest-doc.",
      QUEUED: 'En attente',
      ACTIVE: 'Actifs',
      COMPLETED: 'Terminés',
      WAIT: "Analyse en cours, veuillez patienter…",
    },
    REVIEW: {
      KICKER: 'Contrôle humain',
      TITLE: 'Collaborateurs à importer',
      DESCRIPTION: "Les valeurs importées remplaceront les anciennes par défaut. Cochez uniquement les valeurs existantes à conserver.",
      SEARCH_LABEL: 'Rechercher',
      SEARCH_PLACEHOLDER: 'Nom, e-mail, matricule…',
      STATUS_FILTER: 'État',
      ALL_STATUSES: 'Tous les états',
      PAGE_SIZE: 'Lignes par page',
      TABLE_CAPTION: 'Collaborateurs détectés et état de leur import',
      SELECT_PAGE: 'Sélectionner les lignes prêtes de cette page',
      SELECT_ROW: 'Sélectionner cette ligne',
      SOURCE: 'Source',
      IDENTITY: 'Identité',
      STATUS: 'État',
      ACTIONS: 'Actions',
      CHANGES: 'Changements',
      LINE: 'Ligne',
      PDF: 'PDF',
      NO_RESULTS: 'Aucune ligne ne correspond aux filtres.',
      PAGE: 'Page',
      DETAIL: 'Détail de la ligne',
      EXPAND_DETAILS: 'Afficher les détails de {{name}}',
      COLLAPSE_DETAILS: 'Réduire les détails de {{name}}',
      ROW: 'Ligne importée',
      BLOCKERS: 'Problèmes à corriger',
      QUESTIONS: "Questions de l'IA",
      CONFIRM_STATUS_CHANGE: 'Je confirme individuellement ce changement de statut.',
      AUTOMATIC_EXIT: 'SORTI (automatique)',
      DEPARTURE_DATE_PASSED: "La date de sortie est dépassée. Le collaborateur aura automatiquement le statut SORTI après l'import de ses données, sans confirmation supplémentaire.",
      FREE_TEXT: 'Saisir une autre réponse',
      COLLABORATOR_FIELDS: 'Données du collaborateur',
      CONTRACT: 'Contrat',
      EXISTING: 'Valeur existante',
      IMPORTED: 'Valeur importée',
      EFFECTIVE: 'Valeur retenue',
      EMPTY: 'Vide',
      PROVENANCE: 'Provenance',
      CONFLICT_CHOICE: 'Choix de la valeur à conserver',
      SELECT_DETAIL: 'Sélectionnez une ligne pour consulter et corriger ses données.',
      // La revue simplifiée nomme uniquement les ajouts, remplacements et trois champs obligatoires.
      NEW_VALUE: 'Nouvelle valeur',
      KEEP_OLD_VALUE: "Conserver l'ancienne valeur",
      REQUIRED_FIELDS: 'Informations obligatoires à compléter',
      UNKNOWN_PERSON: 'Collaborateur sans nom',
      NO_CHANGE: 'Aucune valeur ne sera ajoutée ou remplacée.',
      DEFAULT_OVERWRITE: 'Les nouvelles valeurs sont appliquées par défaut.',
      NAME_MATCH_UNAVAILABLE: "Le rapprochement par nom est indisponible (accès COMP requis ou service inaccessible). Le rapprochement par numéro de sécurité sociale reste prioritaire ; renseignez un e-mail pour créer un nouveau collaborateur.",
      SOCIAL_SECURITY_LOOKUP_FAILED: "Certains numéros de sécurité sociale existants n'ont pas pu être vérifiés. Confirmez un candidat par nom ou renseignez un e-mail ; aucun rapprochement SSN incertain n'est appliqué automatiquement.",
    },
    GLOBAL: {
      ORGANIZATION_TITLE: 'Affectations communes à tout l’import',
      ORGANIZATION_HINT: 'Renseignez chaque unité une seule fois pour toutes les pages. Ignorer conserve le salarié sans appliquer ni créer la branche importée ; une affectation existante est conservée. Les corrections individuelles ne sont pas remplacées.',
      PEOPLE: '{{count}} personnes concernées', DECISION: 'Décision commune', CHOOSE: 'Choisir', APPLY: 'Appliquer à toutes les personnes concernées',
      COORDINATES_CONFLICT: 'Les sources indiquent des coordonnées différentes pour ce site. Vérifiez et choisissez explicitement les coordonnées communes avant de créer ; aucune adresse ni aucun pays ne sera inventé.',
      INDIVIDUAL: 'Corriger cette affectation individuellement',
      EMAIL_TITLE: 'E-mails de connexion manquants',
      EMAIL_HINT: 'Confirmez les rapprochements proposés avant de générer les e-mails de connexion. Les saisies individuelles sont conservées et aucun e-mail de contact n’est rempli automatiquement.',
      EMAIL_MAPPING_WARNING: 'Certaines propositions IA ne contiennent pas d’e-mail valide : les téléphones ont été écartés, sans réaffectation automatique. Les adresses mal formées restent à corriger.',
      EMAIL_PATTERN: 'Convention', EMAIL_FIRST: 'prenom@domaine', EMAIL_INITIAL_LAST: 'p.nom@domaine', EMAIL_FIRST_LAST: 'prenom.nom@domaine', EMAIL_MANUAL: 'Saisie manuelle individuelle',
      DOMAIN: 'Domaine explicite (sans @)', PREVIEW: 'Prévisualiser toutes les lignes', EMAIL_INVALID: 'Adresse absente, invalide ou déjà utilisée dans cet import. Corrigez-la manuellement.', APPLY_EMAILS: 'Appliquer et vérifier {{count}} e-mails',
    },
    ROW_STATUS: {
      CREATE: 'À créer',
      UPDATE: 'À mettre à jour',
      UNCHANGED: 'Inchangé',
      BLOCKED: 'Bloqué',
    },
    MATCH: { EMAIL: 'Rapproché par e-mail', MATRICULE: 'Rapproché par matricule', SOCIAL_SECURITY: 'Rapproché par numéro de sécurité sociale', NAME: 'Rapproché par nom et prénom' },
    STRATEGY: {
      KEEP_EXISTING: "Conserver l'existant",
      FILL_EMPTY: 'Compléter le champ vide',
      UNCHANGED: 'Identique',
      USE_IMPORTED: 'Utiliser la valeur importée',
    },
    QUESTION: {
      SOURCE_CONFLICT: 'Plusieurs sources proposent des valeurs différentes. Laquelle faut-il retenir ?',
      EXISTING_CONFLICT: 'La valeur importée est différente de la valeur existante. Laquelle faut-il conserver ?',
      ORGANIZATION: "À quelle unité existante cette donnée correspond-elle, ou faut-il la créer ?",
      MANAGER: 'Quel manager faut-il associer ?',
      REFERENCE: 'Quelle valeur de référence faut-il utiliser ?',
      IDENTITY: "Comment résoudre ce conflit d'identité ?",
      REQUIRED_VALUE: 'Quelle valeur faut-il utiliser pour ce champ obligatoire ?',
      CONTRACT_TARGET: 'Quel contrat faut-il compléter ? Sélectionnez un contrat existant ou renseignez sa date de début.',
    },
    OPTION: {
      WEEK: 'Heures hebdomadaires', MONTH: 'Heures mensuelles (conversion 12/52)',
      KEEP_EXISTING: "Conserver l'existant",
      USE_IMPORTED: 'Utiliser la valeur importée',
      CREATE: 'Créer cet élément',
      UNASSIGNED: 'Laisser non affecté',
      PROVIDE_VALUE: 'Saisir une valeur',
      PROVIDE_PARENT: 'Préciser le parent',
      IGNORE_FIELD: 'Ignorer ce champ',
      IGNORE_ROW: 'Rejeter la ligne',
      CORRECT_EMAIL: "Corriger l'e-mail",
      CORRECT_MATRICULE: 'Corriger le matricule',
    },
    CONFIRMATION: {
      TITLE: "Confirmer le plan d'import",
      DESCRIPTION: 'Les dépendances nécessaires seront ajoutées et exécutées avant les lignes sélectionnées.',
      ROWS: 'Lignes demandées',
      ACTIONS: 'Actions prévues',
      DEPENDENCY_ROWS: 'Lignes de dépendance ajoutées',
    },
    EXECUTION: {
      KICKER: 'Écriture contrôlée',
      TITLE: 'Import en cours',
      DESCRIPTION: "L'écran reste bloqué pendant l'exécution ordonnée des actions.",
      SHARED_DEPENDENCY: 'Dépendance partagée',
      CANCELLATION_PENDING: 'Arrêt demandé…',
    },
    ACTION_STATUS: {
      QUEUED: 'En attente',
      RUNNING: 'En cours',
      SUCCESS: 'Réussie',
      FAILED: 'Échouée',
      SKIPPED_DEPENDENCY_FAILED: 'Ignorée : dépendance en échec',
      CANCELLED: 'Annulée',
    },
    ACTION_TYPE: {
      CREATE_SITE: 'Créer le site',
      CREATE_SERVICE: 'Créer le service',
      CREATE_TEAM: "Créer l'équipe",
      CREATE_COLLABORATOR: 'Créer le collaborateur',
      UPDATE_COLLABORATOR: 'Mettre à jour le collaborateur',
      UPDATE_COLLABORATOR_AFTER_CREATE: 'Compléter le collaborateur créé',
      POLL_INITIAL_CONTRACT: 'Attendre le contrat initial',
      UPDATE_INITIAL_CONTRACT: 'Compléter le contrat initial',
      CREATE_CONTRACT: 'Créer le contrat',
      UPDATE_CONTRACT: 'Mettre à jour le contrat',
      CLOSE_CONTRACT: 'Clore le contrat existant',
      ASSIGN_LEAVE_GROUP: 'Associer le groupe de congés',
      UPLOAD_CONTRACT_DOCUMENT: 'Déposer le contrat dans la GED',
      POLL_UPLOADED_DOCUMENT: "Attendre l'indexation GED",
      ASSOCIATE_CONTRACT_DOCUMENT: 'Associer le document au contrat',
      READ_CONTRACT_DOCUMENT_ASSOCIATION: "Vérifier l'association GED",
      UPDATE_ACCOUNT_STATUS: 'Modifier le statut du collaborateur',
    },
    SUMMARY: {
      KICKER: "Résultat de l'import",
      TITLE: 'Bilan détaillé',
      DESCRIPTION: 'Chaque ligne indique les opérations confirmées et la raison exacte des rejets.',
      STATUS: { INSERTED: 'Inséré', UPDATED: 'Mis à jour', UNCHANGED: 'Inchangé', REJECTED: 'Rejeté', PARTIAL: 'Partiel' },
      TABLE_CAPTION: "Résultats détaillés de l'import",
      LINE: 'Ligne source',
      ROW: 'Enregistrement',
      OUTCOME: 'Résultat',
      CODE: 'Code',
      REASON: 'Raison',
      ACTION: 'Action concernée',
      NO_ACTION: 'Aucune action',
      REASON_CODE: {
        VERIFIED: 'Les données persistées ont été vérifiées.',
        UNCHANGED: 'Aucune donnée ne devait être modifiée.',
        NOT_SELECTED: "La ligne n'a pas été sélectionnée.",
        BLOCKED: 'La ligne contient un problème bloquant.',
        VERIFICATION_FAILED: "La vérification finale n'a pas abouti.",
        VERIFY_MISMATCH: 'La valeur persistée ne correspond pas à la valeur validée.',
        VERIFY_NOT_FOUND: "L'élément créé ou mis à jour est introuvable.",
        VERIFY_NOT_APPLIED: "La modification attendue n'a pas été appliquée.",
        MULTI_CONTRACT_PDF_UNSUPPORTED: 'Le PDF contient plusieurs collaborateurs ou contrats et doit être séparé.',
        MDOC_REQUIRED: "L'option GED MDOC est requise.",
        DOCUMENT_INGEST_FAILED: "L'indexation du document a échoué.",
        SKIPPED_DEPENDENCY_FAILED: 'Une dépendance nécessaire a échoué.',
        CANCELLED: "L'import a été annulé.",
        ACTION_FAILED: "La route métier a rejeté l'opération.",
        ANALYSIS_FAILED: "L'analyse du fichier a échoué.",
      },
    },
    // Les bloqueurs sont des codes stables : leur traduction fournit la raison métier sans révéler d'exception interne.
    BLOCKER: {
      EMAIL_COLLISION: 'Cet e-mail est déjà utilisé par un autre compte ou une autre personne de cet import. Aucun rapprochement automatique ni suffixe ne sera appliqué.',
      ORGANIZATION_COORDINATES_CONFLICT: 'Les coordonnées de ce site contredisent une autre création. Choisissez les coordonnées communes dans le bloc global.',
      CONTRACT_HOURS_UNIT_UNSUPPORTED: 'La période des heures indiquées ne correspond pas à des heures hebdomadaires. Renseignez une valeur hebdomadaire et son unité.',
      SOURCE_CONFLICT: 'Valeurs contradictoires entre plusieurs sources.',
      ORGANIZATION_UNRESOLVED: "L'unité organisationnelle est introuvable ou doit être créée après confirmation.",
      ORGANIZATION_PARENT_REQUIRED: "Le parent de l'unité organisationnelle est manquant.",
      REFERENCE_UNRESOLVED: 'La valeur ne correspond à aucune référence valide.',
      CONTRACT_SITE_UNRESOLVED: 'Le site du contrat est introuvable ou ambigu.',
      LEAVE_GROUP_UNRESOLVED: 'Le groupe de congés est introuvable ou ambigu.',
      IMPORTED_MATRICULE_CONFLICT: 'Plusieurs lignes importées utilisent le même matricule.',
      IDENTITY_AMBIGUOUS: "Plusieurs collaborateurs correspondent à l'identité importée.",
      IDENTITY_SELECTION_INVALID: "Le collaborateur sélectionné n'est pas un salarié de cette entreprise.",
      CONTRACT_TARGET_REQUIRED: 'Aucun contrat actif unique ne peut être retenu. Sélectionnez le contrat à compléter ou précisez sa date de début.',
      EMAIL_MATRICULE_CONFLICT: "L'e-mail et le matricule désignent des collaborateurs différents.",
      NON_COLLABORATOR_ACCOUNT: 'Le compte existant ne possède pas le rôle collaborateur.',
      IGNORED_BY_USER: "La ligne a été rejetée par l'utilisateur.",
      CREATE_REQUIRED_FIELD_MISSING: 'Cette donnée obligatoire doit être renseignée.',
      // Les erreurs de qualité sont affichées directement sous le champ rouge à corriger.
      INVALID_PERSON_NAME: 'Le nom contient des caractères non valides ou dépasse 60 caractères.',
      INVALID_EMAIL: "L'adresse e-mail est mal formée.",
      INVALID_PHONE: 'Le numéro doit contenir entre 7 et 15 chiffres et peut commencer par +.',
      INVALID_COUNTRY_CODE: 'Le pays doit correspondre à un code ISO de 2 caractères, par exemple FR.',
      INVALID_DATE: 'La date est invalide. Utilisez le format AAAA-MM-JJ ou JJ/MM/AAAA.',
      DATE_IN_FUTURE: 'La date de naissance ne peut pas être dans le futur.',
      COLLABORATOR_END_BEFORE_START: "La date de sortie ne peut pas précéder la date d'entrée.",
      ENTRY_BEFORE_BIRTH: "La date d'entrée ne peut pas précéder la date de naissance.",
      CONTRACT_END_BEFORE_START: 'La fin du contrat ne peut pas précéder son début.',
      TRIAL_END_BEFORE_CONTRACT_START: "La fin de période d'essai ne peut pas précéder le début du contrat.",
      SECOND_TRIAL_WITHOUT_FIRST: "La deuxième période d'essai nécessite une première période.",
      SECOND_TRIAL_BEFORE_FIRST: "La deuxième période d'essai ne peut pas finir avant la première.",
      TRIAL_END_AFTER_CONTRACT_END: "La période d'essai ne peut pas finir après le contrat.",
      CONTRACT_START_BEFORE_ENTRY: "Le contrat ne peut pas commencer avant la date d'entrée.",
      CONTRACT_START_AFTER_DEPARTURE: 'Le contrat ne peut pas commencer après la date de sortie.',
      MANAGER_SELF_REFERENCE: 'Un collaborateur ne peut pas être son propre manager.',
      ACCOUNT_STATUS_UNSUPPORTED: 'Le statut demandé ne peut pas être appliqué.',
      ACCOUNT_STATUS_DATE_REQUIRED: 'Une date de sortie est obligatoire pour ce statut.',
      MANAGER_CYCLE: 'La hiérarchie des managers contient une boucle.',
      MANAGER_DEPENDENCY_BLOCKED: 'La ligne du manager est bloquée.',
      MULTI_CONTRACT_PDF_UNSUPPORTED: 'Un PDF doit contenir exactement un collaborateur et un contrat.',
    },
    ERROR: {
      WORKFLOW_LIMIT: "La limite cumulee d'appels, d'outils, de tokens ou de temps est atteinte. Aucune operation supplementaire ne sera lancee.",
      WORKFLOW_NOT_FOUND: "Cette reprise est expiree, deja utilisee ou inaccessible. Aucun traitement n'a ete relance.",
      WORKFLOW_KEY_UNAVAILABLE: 'La protection de la reprise est indisponible. Le traitement est refuse.',
      WORKFLOW_STATE_UNAVAILABLE: 'Le suivi durable est indisponible. Aucune nouvelle operation ne sera lancee.',
      WORKFLOW_BUSY: 'Cette operation est deja prise en charge par un autre traitement.',
      WORKFLOW_API_UNAVAILABLE: "L'API metier configuree est indisponible.",
      WORKFLOW_ACTION_INVALID: "Le plan ou sa cible n'est plus valide. Aucune nouvelle ecriture n'est autorisee.",
      ACTION_AMBIGUOUS: "Le resultat d'une operation est incertain. Verifiez la fiche ; aucune creation ne sera relancee automatiquement.",
      GENERIC: "Une erreur inattendue empêche de poursuivre l'import.",
      NETWORK_ERROR: "La connexion au serveur a été interrompue. Vérifiez que le backend est disponible puis relancez l'analyse.",
      MAX_FILES: 'Vous pouvez sélectionner au maximum 20 fichiers.',
      FILE_TYPE: 'Le format de ce fichier n’est pas pris en charge.',
      FILE_SIZE: 'Le fichier est vide ou dépasse la taille autorisée.',
      DUPLICATE_FILE: 'Ce fichier est déjà sélectionné.',
      NO_ANALYZED_ROWS: 'Aucune donnée collaborateur exploitable n’a été détectée.',
      MAX_COLLABORATORS: 'Le nombre total de collaborateurs dépasse 1 000.',
      STATUS_CONFIRMATION_REQUIRED: 'Confirmez individuellement le changement de statut.',
      NO_READY_SELECTION: 'Sélectionnez au moins une ligne prête.',
      VERIFICATION_FAILED: 'Les écritures sont terminées, mais leur vérification finale a échoué.',
      INVALID_FILE: 'Le fichier est invalide ou ne correspond pas à son extension.',
      FILE_TOO_LARGE: 'Le fichier dépasse la taille autorisée.',
      PDF_PAGE_LIMIT_EXCEEDED: 'Le PDF dépasse 20 pages ou son nombre de pages est illisible.',
      ROW_LIMIT_EXCEEDED: 'Le fichier dépasse la limite de 1 000 collaborateurs.',
      COLUMN_LIMIT_EXCEEDED: 'Le tableur dépasse la limite de colonnes.',
      CELL_LIMIT_EXCEEDED: 'Le tableur ou une cellule dépasse la limite autorisée.',
      UNSUPPORTED_FIELD: 'Une donnée cible un champ non importable.',
      INVALID_REQUEST: 'Les données de revue sont invalides.',
      // Les erreurs multipart indiquent précisément la métadonnée qui empêche l'analyse du fichier.
      INVALID_CLIENT_FILE_ID: "L'identifiant interne du fichier est invalide. Retirez-le puis ajoutez-le de nouveau.",
      INVALID_REQUEST_ID: "L'identifiant de la requête est invalide. Relancez l'analyse.",
      INVALID_IMPORT_ID: "La session d'import est invalide ou provient d'une ancienne version. Rechargez la page puis relancez l'import.",
      INVALID_LANGUAGE: "La langue de l'import est invalide.",
      EXTRACTION_INVALID: 'Les données extraites ne respectent pas le format attendu.',
      INGEST_DOC_UNAVAILABLE: 'Le service d’extraction OCR est indisponible.',
      OCR_TIMEOUT: "L'extraction OCR a dépassé le délai autorisé.",
      OCR_EMPTY: "Le service OCR n'a extrait aucun texte.",
      MULTI_CONTRACT_PDF_UNSUPPORTED: 'Le PDF doit contenir exactement un collaborateur et un contrat.',
      AI_CREDIT_EXHAUSTED: 'Le crédit IA disponible est insuffisant.',
      AI_PROVIDER_ERROR: 'Le service IA n’a pas terminé l’analyse.',
      ADMIN_REQUIRED: 'Seul un administrateur peut utiliser cet import.',
      UNAUTHORIZED: 'Votre session n’est plus valide.',
      RATE_LIMITED: 'Le service est occupé. Le traitement reprendra automatiquement.',
      REQUEST_CANCELLED: 'La requête a été annulée.',
      INTERNAL_ERROR: 'Le traitement n’a pas pu être terminé.',
      ACTION_HTTP_ERROR: 'La route métier a rejeté cette opération.',
      ACTION_RESULT_ID_MISSING: "La route métier n'a pas renvoyé l'identifiant attendu.",
      DOCUMENT_INGEST_FAILED: "L'indexation GED du document a échoué.",
      POLL_TIMEOUT: "L'attente de la ressource créée a expiré.",
    },
    // Les clés de champs sont partagées par toutes les lignes et tous les contrats, quel que soit leur index.
    FIELD: {
      IDENTITY: 'Identité',
      MANAGER: 'Manager',
      ORGANIZATION_SITE_NAME: 'Site',
      ORGANIZATION_SITE_ADDRESS: 'Adresse du site à créer',
      ORGANIZATION_SITE_COUNTRY: 'Pays du site à créer',
      ORGANIZATION_SITE_CITY: 'Ville du site',
      ORGANIZATION_SERVICE_NAME: 'Service',
      ORGANIZATION_TEAM_NAME: 'Équipe',
      MANAGER_EMAIL: 'E-mail du manager',
      MANAGER_MATRICULE: 'Matricule du manager',
      MANAGER_NAME: 'Nom du manager',
      COLLABORATOR_LOGIN_EMAIL: 'E-mail de connexion',
      COLLABORATOR_NOM: 'Nom',
      COLLABORATOR_PRENOM: 'Prénom',
      COLLABORATOR_FONCTION: 'Fonction',
      COLLABORATOR_DATE_ENTRE: "Date d'entrée",
      COLLABORATOR_DATE_FIN: 'Date de sortie',
      COLLABORATOR_MAIL_PERSONNEL: 'E-mail personnel',
      COLLABORATOR_MAIL_PRO: 'E-mail professionnel',
      COLLABORATOR_GENRE: 'Genre',
      COLLABORATOR_DATE_NAISSANCE: 'Date de naissance',
      COLLABORATOR_PRESENTATION: 'Présentation',
      COLLABORATOR_USER_LANGUE: 'Langue',
      COLLABORATOR_PROCESSUS_ONBOARDING: "Processus d'onboarding",
      COLLABORATOR_PAYS_USER: 'Pays',
      COLLABORATOR_VILLE_USER: 'Ville',
      COLLABORATOR_ADRESSE_USER: 'Adresse',
      COLLABORATOR_CODE_POSTAL: 'Code postal',
      COLLABORATOR_TELEPHONE: 'Téléphone personnel',
      COLLABORATOR_TELEPHONE_PROFESSIONEL: 'Téléphone professionnel',
      COLLABORATOR_LIEN_LINKEDIN: 'LinkedIn',
      COLLABORATOR_ETAT_CIVIL: 'État civil',
      COLLABORATOR_SITUATION_FAMILIALE: 'Situation familiale',
      COLLABORATOR_LIEU_NAISSANCE: 'Lieu de naissance',
      COLLABORATOR_DEPARTEMENT_NAISSANCE: 'Département de naissance',
      COLLABORATOR_NUM_ENFANTS: "Nombre d'enfants",
      COLLABORATOR_COMPLEMENT_ADRESS: "Complément d'adresse",
      COLLABORATOR_QUALIFICATION: "Niveau d'étude",
      COLLABORATOR_NATIONALITE: 'Nationalité',
      COLLABORATOR_CITOYENNETE: 'Citoyenneté',
      COLLABORATOR_NUM_SECURITE_SOCIAL: 'Numéro de sécurité sociale',
      COLLABORATOR_NUM_PASSPORT: 'Numéro de passeport',
      COLLABORATOR_CIN: "Numéro de pièce d'identité",
      COLLABORATOR_USER_CONTACT_URGENCE: "Contact d'urgence",
      COLLABORATOR_RELATION_USER_URGENCE: "Relation du contact d'urgence",
      COLLABORATOR_PHONE_USER_URGENCE: "Téléphone du contact d'urgence",
      COLLABORATOR_ADRESSE_USER_URGENCE: "Adresse du contact d'urgence",
      COLLABORATOR_DATE_AUTORISATION_EMBAUCHE: "Date d'autorisation d'embauche",
      COLLABORATOR_DATE_AUTORISATION_LICENCIEMENT: "Date d'autorisation de licenciement",
      COLLABORATOR_DATE_ENTREE_GROUPE: "Date d'entrée dans le groupe",
      COLLABORATOR_ACCOUNT_STATUS: 'Statut du compte',
      CONTRACT_CONTRAT_TYPE: 'Type de contrat',
      CONTRACT_COUNTRY: 'Juridiction du contrat', CONTRACT_HOURS_UNIT: 'Période des heures du contrat',
      CONTRACT_DT_DEB: 'Date de début du contrat',
      CONTRACT_DT_FIN: 'Date de fin du contrat',
      CONTRACT_DT_FIN_ESSAI_1: "Fin de la première période d'essai",
      CONTRACT_DT_FIN_ESSAI_2: "Fin de la seconde période d'essai",
      CONTRACT_TEMPS: 'Temps de travail',
      CONTRACT_MOTIF_DEBUT: 'Motif de début',
      CONTRACT_MOTIF_FIN: 'Motif de fin',
      CONTRACT_CATEGORIE: 'Catégorie',
      CONTRACT_MATRICULE: 'Matricule',
      CONTRACT_NOM_ENTREPRISE: "Nom de l'employeur",
      CONTRACT_ADRESSE_ENTREPRISE: "Adresse de l'employeur",
      CONTRACT_NOM_ENTREPRISE_GROUPEMENT: 'Nom du groupement',
      CONTRACT_ADRESSE_ENTREPRISE_GROUPEMENT: 'Adresse du groupement',
      CONTRACT_NOMBRE_HEURE: "Nombre d'heures hebdomadaires",
      CONTRACT_FORFAIT_TYPE: 'Type de forfait',
      CONTRACT_SITE_NAME: 'Site du contrat',
      CONTRACT_LEAVE_GROUP_NAME: 'Groupe de congés',
    },
  },
}

// L'export suit le format des autres vocabulaires modulaires chargés par le dictionnaire racine.
export default COLLABORATOR_AI_IMPORT_FR
